const initialState = {
  widgetDrawer: {
    title: '',
    replaceMode: false,
    replaceIndex: null
  },
  widgetDetailsDrawer: {
    title: '',
    drawerContents: null
  },
  highlights: {
    topOperator: {},
    trendingSales: {},
    trendingCategory: {},
    biggestGrowthOpportunity: {}
  },
  highlightsLoading: false,
  defaultDatasetsLoaded: false,
  itemLevelDescriptionData: [],
  itemLevelDescriptionLoading: false,
  itemMatchData: [],
  itemMatchLoading: false,
  widgets: [],
  widgetData: {
    salesByOperatorData: [],
    salesByCategoryData: [],
    opportunityByStoreData: [],
    newLocationsData: [],
    lostLocationsData: [],
    salesVoidData: [],
    growthOpportunityData: [],
    leakageData: [],
    targetsByCategoryData: [],
    competitiveInsightsData: [],
    topProductsData: [],
    topCategoriesData: [],
    segmentOverviewData: []
  },
  widgetDetailsData: {
    salesByOperatorData: [],
    salesByCategoryData: [],
    opportunityByStoreData: [],
    newLocationsData: [],
    lostLocationsData: [],
    salesVoidData: [],
    growthOpportunityData: [],
    leakageData: [],
    targetsByCategoryData: [],
    competitiveInsightsData: [],
    topProductsData: [],
    topCategoriesData: [],
    segmentOverviewData: []
  },
  isLoading: {
    salesByOperatorLoading: false,
    salesByCategoryLoading: false,
    opportunityByStoreLoading: false,
    newLocationsLoading: false,
    lostLocationsLoading: false,
    salesVoidLoading: false,
    growthOpportunityLoading: false,
    leakageLoading: false,
    targetsByCategoryLoading: false,
    competitiveInsightsLoading: false,
    topProductsLoading: false,
    topCategoriesLoading: false,
    detailsPageLoading: false,
    segmentOverviewLoading: false
  },
  detailsIsLoading: {
    salesByOperatorLoading: false,
    salesByCategoryLoading: false,
    opportunityByStoreLoading: false,
    newLocationsLoading: false,
    lostLocationsLoading: false,
    salesVoidLoading: false,
    growthOpportunityLoading: false,
    leakageLoading: false,
    targetsByCategoryLoading: false,
    competitiveInsightsLoading: false,
    topProductsLoading: false,
    topCategoriesLoading: false,
    segmentOverviewLoading: false
  }
}

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case 'SET_DATASUITE_SLIDE_DRAWER_CONTENTS' :
      return {
        ...state,
        widgetDrawer: {
          title: action.payload.title,
          replaceMode: action.payload.replaceMode,
          replaceIndex: action.payload.replaceIndex
        }
      }
    case 'SET_DATASUITE_DETAILS_SLIDE_DRAWER_CONTENTS' :
      return {
        ...state,
        widgetDetailsDrawer: {
          title: action.payload.title,
          drawerContents: action.payload.drawerContents
        }
      }
    case 'SET_DATASUITE_WIDGETS' :
      return {
        ...state,
        widgets: action.payload
      }
    case 'SET_DATASUITE_HIGHLIGHTS_TOPOPERATOR' :
      return {
        ...state,
        highlights: {
          ...state.highlights,
          topOperator: action.payload
        }
      }
    case 'SET_DATASUITE_HIGHLIGHTS_TRENDINGSALES' :
      return {
        ...state,
        highlights: {
          ...state.highlights,
          trendingSales: action.payload
        }
      }
    case 'SET_DATASUITE_HIGHLIGHTS_TRENDINGCATEGORY' :
      return {
        ...state,
        highlights: {
          ...state.highlights,
          trendingCategory: action.payload
        }
      }
    case 'SET_DATASUITE_HIGHLIGHTS_BIGGESTGROWTHOPPORTUNITY' :
      return {
        ...state,
        highlights: {
          ...state.highlights,
          biggestGrowthOpportunity: action.payload
        }
      }
    case 'SET_DATASUITE_HIGHLIGHTS_LOADING' :
      return {
        ...state,
        highlightsLoading: action.payload
      }
    case 'SET_DATASUITE_WIDGETS_SALESBYOPERATOR' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          salesByOperatorData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_SALESBYOPERATOR_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          salesByOperatorData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_SALESBYCATEGORY' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          salesByCategoryData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_SALESBYCATEGORY_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          salesByCategoryData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_GROWTHOPPORTUNITY' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          growthOpportunityData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_GROWTHOPPORTUNITY_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          growthOpportunityData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_LEAKAGE' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          leakageData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_LEAKAGE_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          leakageData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_TARGETSBYCATEGORY' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          targetsByCategoryData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_TARGETSBYCATEGORY_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          targetsByCategoryData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_COMPETITIVEINSIGHTS' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          competitiveInsightsData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_COMPETITIVEINSIGHTS_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          competitiveInsightsData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_OPPORTUNITYBYSTORE' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          opportunityByStoreData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_OPPORTUNITYBYSTORE_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          opportunityByStoreData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_NEWLOCATIONS' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          newLocationsData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_NEWLOCATIONS_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          newLocationsData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_LOSTLOCATIONS' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          lostLocationsData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_LOSTLOCATIONS_DETAILS' :
    return {
      ...state,
      widgetDetailsData: {
        ...state.widgetDetailsData,
        lostLocationsData: action.payload
      }
    }
    case 'SET_DATASUITE_WIDGETS_SALESVOIDOPPORTUNITY' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          salesVoidData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_SALESVOIDOPPORTUNITY_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          salesVoidData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_TOPPRODUCTS' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          topProductsData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_TOPPRODUCTS_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          topProductsData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_TOPCATEGORIES' :
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          topCategoriesData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_TOPCATEGORIES_DETAILS' :
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          topCategoriesData: action.payload
        }
      }
    case 'SET_DATASUITE_WIDGETS_SEGMENTOVERVIEW':
      return {
        ...state,
        widgetData: {
          ...state.widgetData,
          segmentOverviewData: action.payload
        }
      }

    case 'SET_DATASUITE_WIDGETS_SEGMENTOVERVIEW_DETAILS':
      return {
        ...state,
        widgetDetailsData: {
          ...state.widgetDetailsData,
          segmentOverviewData: action.payload
        }
      }
    case 'SET_SALESBYOPERATOR_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          salesByOperatorLoading: action.payload
        }
      }
    case 'SET_SALESBYCATEGORY_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          salesByCategoryLoading: action.payload
        }
      }
    case 'SET_GROWTHOPPORTUNITY_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          growthOpportunityLoading: action.payload
        }
      }
    case 'SET_LEAKAGE_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          leakageLoading: action.payload
        }
      }
    case 'SET_TARGETSBYCATEGORY_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          targetsByCategoryLoading: action.payload
        }
      }
    case 'SET_COMPETITIVEINSIGHTS_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          competitiveInsightsLoading: action.payload
        }
      }
    case 'SET_OPPORTUNITYBYSTORE_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          opportunityByStoreLoading: action.payload
        }
      }
    case 'SET_NEWLOCATIONS_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          newLocationsLoading: action.payload
        }
      }
    case 'SET_LOSTLOCATIONS_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          lostLocationsLoading: action.payload
        }
      }
    case 'SET_SALESVOID_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          salesVoidLoading: action.payload
        }
      }
    case 'SET_TOPPRODUCTS_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          topProductsLoading: action.payload
        }
      }
    case 'SET_TOPCATEGORIES_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          topCategoriesLoading: action.payload
        }
      }
    case 'SET_SEGMENTOVERVIEW_ISLOADNG':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          segmentOverviewLoading: action.payload
        }
      }
    case 'SET_ITEM_LEVEL_DESCRIPTION_DATA': 
      return {
        ...state,
        itemLevelDescriptionData: action.payload
      }
    case 'SET_ITEM_LEVEL_DESCRIPTION_LOADING':
      return {
        ...state,
        itemLevelDescriptionLoading: action.payload
      }
    case 'SET_ITEM_MATCH_DATA':
      return {
        ...state,
        itemMatchData: action.payload
      }
    case 'SET_ITEM_MATCH_LOADING':
      return {
        ...state,
        itemMatchLoading: action.payload
      }
    case 'SET_DETAILS_PAGE_LOADING':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          detailsPageLoading: action.payload
        }
      }
    case 'SET_SALESBYOPERATORDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          salesByOperatorLoading: action.payload
        }
      }
    case 'SET_SALESBYCATEGORYDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          salesByCategoryLoading: action.payload
        }
      }
    case 'SET_GROWTHOPPORTUNITYDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          growthOpportunityLoading: action.payload
        }
      }
    case 'SET_LEAKAGEDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          leakageLoading: action.payload
        }
      }
    case 'SET_TARGETSBYCATEGORYDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          targetsByCategoryLoading: action.payload
        }
      }
    case 'SET_COMPETITIVEINSIGHTSDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          competitiveInsightsLoading: action.payload
        }
      }
    case 'SET_OPPORTUNITYBYSTOREDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          opportunityByStoreLoading: action.payload
        }
      }
    case 'SET_NEWLOCATIONSDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          newLocationsLoading: action.payload
        }
      }
    case 'SET_LOSTLOCATIONSDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          lostLocationsLoading: action.payload
        }
      }
    case 'SET_SALESVOIDDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          salesVoidLoading: action.payload
        }
      }
    case 'SET_TOPPRODUCTSDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          topProductsLoading: action.payload
        }
      }
    case 'SET_TOPCATEGORIESDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          topCategoriesLoading: action.payload
        }
      }
    case 'SET_SEGMENTOVERVIEWDETAILS_ISLOADNG':
      return {
        ...state,
        detailsIsLoading: {
          ...state.detailsIsLoading,
          segmentOverviewLoading: action.payload
        }
      }
    case 'CLEAR_DATASUITE_HIGHLIGHTS' :
      return {
        ...state,
        highlights: {
          topOperator: {},
          trendingSales: {},
          trendingCategory: {},
        },
        selectedDetailsFilters: {
          chainData: false,
          gpoData: false,
          includedSearch: [],
          excludedSearch: [],
          categories: [],
          distributors: [],
          locations: [],
          segments: [],
          states: [],
          countries: [],
          children: []
        },
        widgetData: {
          salesByOperatorData: [],
          salesByCategoryData: [],
          opportunityByStoreData: [],
          newLocationsData: [],
          lostLocationsData: [],
          salesVoidData: [],
          growthOpportunityData: [],
          leakageData: [],
          targetsByCategoryData: [],
          competitiveInsightsData: [],
          topProductsData: [],
          topCategoriesData: [],
        },
        widgetDetailsData: {
          salesByOperatorData: [],
          salesByCategoryData: [],
          opportunityByStoreData: [],
          newLocationsData: [],
          lostLocationsData: [],
          salesVoidData: [],
          growthOpportunityData: [],
          leakageData: [],
          targetsByCategoryData: [],
          competitiveInsightsData: [],
          topProductsData: [],
          topCategoriesData: [],
        },
        exportDetailsFilters: {
          chainData: false,
          gpoData: false,
          categories: [],
          distributors: [],
          locations: [],
          states: [],
          countries: [],
          segments: []
        },
        compExportDetailsFilters: {
          chainData: false,
          gpoData: false,
          categories: [],
          locations: [],
          states: [],
          countries: [],
          segments: []
        },
        itemLevelDescriptionData: [],
        itemMatchData: []
      }
    case 'CLEAR_DATASUITE' :
      return initialState;
    default:
      return state;
  };
};
